/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 27/01/22
 */

import { User } from '@/wpt-lib/interfaces/User';
import { FacultyAdmin, OrganisationAdmin } from '@/wpt-lib/interfaces/FacultyAdmin';
import { Supervisor } from '@/wpt-lib/interfaces/Supervisor';
import { Organisation } from '@/wpt-lib/interfaces/Organisation';
import { WorkloadStaffType, Workplan } from './Workplan';

export interface Assignment {
    id: number;
    assignmentNumber: string;
    name: string;

    fte: number;
    workloadCategory?: string | null;
    hasCustomWorkloadPortions: boolean;
    teachingWorkloadPortion: number;
    researchWorkloadPortion: number;
    serviceWorkloadPortion: number;
    seniorStaffWorkloadPortion: number;
    professionalStaffWorkloadPortion: number;
    staffType: WorkloadStaffType;

    gradeName: string | null;

    probationEndDate?: string | null;
    probationPeriod?: string | null;
    probationUnit?: string | null;

    isGlobalAdmin: boolean;
    inactive: boolean;

    userId: number;
    user?: User;
    workplans?: Workplan[];

    adminFaculties?: FacultyAdmin[];
    adminOrganisations?: OrganisationAdmin[];

    supervisors?: Supervisor[];
    organisation: Organisation;
}

export enum AssignmentChange {
    SUPERVISOR_ADDED = 'SUPERVISOR_ADDED',
    SUPERVISOR_REMOVED = 'SUPERVISOR_REMOVED',
    ACTIVATED = 'ACTIVATED',
    INACTIVATED = 'INACTIVATED',
    UPDATED_WORKPLAN = 'UPDATED_WORKPLAN',
    CREATED = 'CREATED',
    UPDATED = 'UPDATED',
    DELETED = 'DELETED',
}

export enum AssignmentStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export enum Reason {
    ChangeOfAssignment = 'Change of Assignment',
    LeftUTS = 'Left UTS',
    UnplannedExtendedLeave = 'Unplanned extended leave',
}

export interface AssignmentChangeHistory {
    id: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
    change: AssignmentChange;
    assignment: Assignment;
    changedBy: Assignment;
    reason: string | null;
}

export interface Workload {
    teachingWorkloadPortion: number;
    researchWorkloadPortion: number;
    serviceWorkloadPortion: number;
    seniorStaffWorkloadPortion: number;
    professionalStaffWorkloadPortion: number;
    staffType: WorkloadStaffType;
}
